module.exports = __webpack_public_path__ + "static/media/cancel.ca2cad8f.svg";